import Link from "next/link";
import { withRouter, useRouter } from "next/router";
import { useAdminLayoutContext } from "../../contexts/AdminLayout";
import { MERCHANT_BASE_URL } from "../../utils/constants";
import { useUser } from "../../utils/UserContext";
import { useState } from "react";
import Modal from "react-modal";




export default withRouter(({ router: { pathname } }) => {
  const { apps, tenantId, merchantStatus, roles, lastname } = useUser();
  const stage = merchantStatus ? merchantStatus.code : -1;
  const { openSidebar } = useAdminLayoutContext();
  const [modalOpen, setModalOpen] = useState(false);
  const [isNavigating, setIsNavigating] = useState(false); // State to track navigation
  const router = useRouter();

  const handleListModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

const handleIntermdaClick = () => {
  if (router.pathname === `${MERCHANT_BASE_URL}/intermda`) {
    window.location.reload();
  } else {
    router.push(`${MERCHANT_BASE_URL}/intermda`, undefined, { shallow: true });
  }
};



  return (
    <div className={`ci-sidebar ${openSidebar ? "ci-sidebar_open" : ""}`}>
      <div className="ci-sidebar-content">
        <ul className="ci-sidebar-menu">
          <li
            className={`ci-sidebar-menu_item ${
              MERCHANT_BASE_URL === pathname ? "active" : ""
            }`}
          >
            <Link href={`${MERCHANT_BASE_URL}`}>
              <a href="#" className="ci-sidebar-menu_link">
                <img src="/static/img/1Gov/Apps.svg" alt="" />
                <span>Apps</span>
              </a>
            </Link>
          </li>
          <li
            className={`ci-sidebar-menu_item ${
              MERCHANT_BASE_URL + "/mobile-apps" === pathname ? "active" : ""
            }`}
          >
            <Link href={`${MERCHANT_BASE_URL}/mobile-apps`}>
              <a href="#" className="ci-sidebar-menu_link">
                <img src="/static/img/1Gov/mobileicon.svg" alt="" />
                <span>Mobile Apps</span>
              </a>
            </Link>
          </li>
          <li
            className={`ci-sidebar-menu_item ${
              MERCHANT_BASE_URL + "/intermda" === pathname ? "active" : ""
            }`}
          >
            <a onClick={handleIntermdaClick} className="ci-sidebar-menu_link">
              <img src="/static/img/1Gov/intermda.svg" alt="" />
              <span>Inter MDA</span>
            </a>
          </li>
          {/* {apps && apps.ucg && (
            <li className="ci-sidebar-menu_item">
              <a
                href="#"
                data-toggle="collapse"
                data-target="#collapseInvoice"
                aria-expanded="false"
                aria-controls="collapseInvoice"
                className="ci-sidebar-menu_link collapsed"
              >
                <img src="/static/img/receipt.svg" alt="" />
                <span>Quick Invoice</span>
                <i className="fas fa-angle-down"></i>
              </a>
              <div className="accordion" id="accordionQuickRequest">
                <div
                  id="collapseInvoice"
                  className="collapse"
                  aria-labelledby="headingOne"
                  data-parent="#accordionQuickRequest"
                >
                  <div className="ci-sidebar-submenu">
                    <Link href={`${MERCHANT_BASE_URL}/quick-request`}>
                      <a className="ci-sidebar-submenu_link">Create / Drafts</a>
                    </Link>
                    <Link href={`${MERCHANT_BASE_URL}/quick-request/history`}>
                      <a className="ci-sidebar-submenu_link">Sent Invoices</a>
                    </Link>
                  </div>
                </div>
              </div>
            </li>
          )} */}

          {roles === "SUPERADMIN" && (
            <li className="ci-sidebar-menu_item">
              <a
                href="#"
                data-bs-toggle="collapse"
                data-bs-target="#collapseBilling"
                aria-expanded="false"
                aria-controls="collapseBilling"
                className="ci-sidebar-menu_link collapsed"
              >
                <img src="/static/img/1Gov/Billing.svg" alt="" />
                <span>Billing</span>
                <i className="fas fa-angle-down"></i>
              </a>
              <div className="accordion" id="accordionQuickRequest">
                <div
                  id="collapseBilling"
                  className="collapse"
                  aria-labelledby="headingOne"
                  data-parent="#accordionQuickRequest"
                >
                  <div className="ci-sidebar-submenu">
                    <Link href={`${MERCHANT_BASE_URL}/billing`}>
                      <a className="ci-sidebar-submenu_link">Subscription</a>
                    </Link>
                    <Link href={`${MERCHANT_BASE_URL}/billing/history`}>
                      <a className="ci-sidebar-submenu_link">
                        Billing and Invoice History
                      </a>
                    </Link>
                  </div>
                </div>
              </div>
            </li>
          )}
          <li
            className={`ci-sidebar-menu_item ${
              MERCHANT_BASE_URL + "/administration" === pathname ? "active" : ""
            }`}
          >
            <Link href={`${MERCHANT_BASE_URL}/administration`}>
              <a className="ci-sidebar-menu_link">
                <img src="/static/img/1Gov/Admin.svg" alt="" />
                <span>Administration</span>
              </a>
            </Link>
          </li>
        </ul>
      </div>

      <div className="support-sect">
        <img src="/static/img/1Gov/write.svg" alt="" />
        <p>
          Need assistance? Report an issue or give feedback, click the button
          below
        </p>
        <a
          href="https://support.1gov.ng/"
          target="_blank"
          className="cicod-btn cicod-btn-blue-small"
          // onClick={handleListModal}
        >
          Contact 1Government Support
        </a>
      </div>

      <Modal
        isOpen={modalOpen}
        onRequestClose={closeModal}
        contentLabel="List Modal"
        style={{
          overlay: {
            backgroundColor: "transparent",
            width: "70%",
            textAlign: "center", // Set the width as needed
            margin: "auto", // Center the modal horizontally
          },
          content: {
            height: "100%", // Set the height as needed
            // Center the modal vertically
          },
        }}
      >
        <div>
          <button onClick={closeModal} style={{ float: "right" }}>
            X
          </button>
          <iframe
            src="https://gbb.1gov.ng/webform/Support%2520Form"
            style={{
              width: "70%",
              height: "100vh",
              borderRadius: "10px",
              border: "none",
            }}
          ></iframe>
        </div>
      </Modal>
    </div>
  );
});
